/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLockX = createReactComponent("outline", "lock-x", "IconLockX", [["path", { "d": "M13 21h-6a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v.5", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-3" }], ["path", { "d": "M17 22l5 -5", "key": "svg-4" }]]);

export { IconLockX as default };
//# sourceMappingURL=IconLockX.mjs.map
